import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { withQueryParams } from "../helpers/common.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "date-fns";
import "date-fns/locale";
import "../appointment-details.types.js";
import "react/jsx-runtime";
import "axios";
const getEmployeesList = (axios) => async (params) => {
  const { data } = await axios.get("/api/practitioners", {
    params
  });
  return data ?? [];
};
const useEmployeeSearch = ({ clinicReferenceId, treatmentReferenceId }) => {
  const { calmaster, auth } = useAxiosProvider();
  const params = useMemo(
    () => ({
      clinicReferenceId,
      treatmentReferenceId
    }),
    [clinicReferenceId, treatmentReferenceId]
  );
  const queryKey = useMemo(() => ["employees", params], [params]);
  const enabled = !!clinicReferenceId && !!treatmentReferenceId && !!auth;
  const { data, ...queryResult } = useQuery({
    // @ts-expect-error TODO:
    queryKey,
    queryFn: withQueryParams(getEmployeesList(calmaster)),
    keepPreviousData: true,
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useEmployeeSearch
};
